import authRequest from "@/api/http/authRequest";
import http from "@/api/http/http";
import axios from "axios";

export default {
  createLessonContentUnlockCode (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/lesson-content-unlock-code`, params, cb, errCb)
  },
  updateLessonContentUnlockCode (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/lesson-content-unlock-code/${params.id}`, params, cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/lesson-content-unlock-code/${id}`, cb, errCb)
  },
  deleteAll ( cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/lesson-content-unlock-code/all`, cb, errCb)
  },
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/lesson-content-unlock-code/search`, params, cb, errCb)
  },
  exportExcel( params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/lesson-content-unlock-code/export`,
      responseType: 'blob',
      data: params,
      ...header
    })
      .then(cb)
      .catch((error) => {
        console.log('error', error)
        if (error.response && error.response.data && error.response.data.message) {
          errCb(error.response.data);
        } else {
          errCb({ message: "An unknown error occurred" });
        }
      })
  },
  bulkCreate( params: any, cb: (response) => void, errCb: (response) => void) {
    const header = http.setHeaders()
    axios({
      method: 'post',
      url: `${process.env.VUE_APP_API}/admin/lesson-content-unlock-code/bulk`,
      responseType: 'blob',
      data: params,
      ...header
    })
      .then(cb)
      .catch((error) => {
        console.log('error', error)
        if (error.response && error.response.data && error.response.data.message) {
          errCb(error.response.data);
        } else {
          errCb({ message: "An unknown error occurred" });
        }
      })
  },
}
